import { RootState } from "../../../store";
import { dimensionsSliceSelector } from "../dimensionsSliceSelector";

export const dimensionDrawerModeSelector = (state: RootState) => {
  const slice = dimensionsSliceSelector(state);

  return slice.drawerMode;
};
